/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import translate from 'services/i18n/translate';
import { Rail } from 'ui/components';
import { Asset } from '@wit/vtv-x-foundation-lib';

interface Props {
  onCardClick?: (asset: Asset, menuItemId?: number) => void;
  onClose: () => void;
  secondsToStart?: number;
  button?: {
    label: string;
    handler: () => void;
  };
  asset?: Asset;
  menuItemId?: number;
}

function SideSuggestion({
  onCardClick,
  onClose,
  secondsToStart,
  button,
  asset,
  menuItemId,
}: Props): JSX.Element | null {
  return asset ? (
    <div className="side-suggestions" id="UpNextSideSuggestion">
      <div className="suggestion-close" onClick={onClose} id="UpNextSideSuggestion_onClose" />
      <hgroup className="autoplay-heading">
        <h6 id="UpNextSideSuggestion_title">{translate['watchtv.sideNotification.nextEpisode']}</h6>
        {secondsToStart ? (
          <h3>
            <span>{translate['watchtv.sideNotification.playingIn']}</span>
            <span className="auto-play-time" id="UpNextSideSuggestion_secondsToStart">
              {' '}
              {secondsToStart}{' '}
            </span>
            <span className="auto-play-time">{translate['watchtv.sideNotification.seconds.short']}</span>
          </h3>
        ) : (
          <h3>
            <span>{translate['upnextRecommendations.click']}</span>
          </h3>
        )}
      </hgroup>
      <Rail
        railId="sideSuggestion"
        showSeriesInfo
        assets={[asset]}
        menuItemId={menuItemId}
        maxNumberOfAssets={1}
        onCardClick={onCardClick}
      />
      {button && (
        <a className="btn gradient-btn" onClick={() => button.handler()} id="UpNextSideSuggestion_labelButton">
          <span>{button.label}</span>
        </a>
      )}
    </div>
  ) : null;
}
export default React.memo(SideSuggestion);
